import { MHCRoles } from "src/app/providers/permissions/mhc-roles";

export enum AdminRoleAction {
  UpdateDfsChequeTracker = "UpdateDfsChequeTracker",
  UpdateLogisticsPage = "UpdateLogisticsPage",
  UpdateCompaniesConfiguration = "UpdateCompaniesConfiguration",
}

const matrixManagedRoles = new Set<string>([
  MHCRoles.SALES_OFFICER,
  MHCRoles.TREASURER,
  MHCRoles.ACCOUNTS_OFFICER,
  MHCRoles.ADMIN,
  MHCRoles.AUDIT,
]);

const matrixRoleActionPolicy: Record<
  string,
  Partial<Record<AdminRoleAction, boolean>>
> = {
  [MHCRoles.SALES_OFFICER]: {
    [AdminRoleAction.UpdateDfsChequeTracker]: false,
    [AdminRoleAction.UpdateLogisticsPage]: false,
    [AdminRoleAction.UpdateCompaniesConfiguration]: true,
  },
  [MHCRoles.TREASURER]: {
    [AdminRoleAction.UpdateDfsChequeTracker]: true,
    [AdminRoleAction.UpdateLogisticsPage]: false,
    [AdminRoleAction.UpdateCompaniesConfiguration]: false,
  },
  [MHCRoles.ACCOUNTS_OFFICER]: {
    [AdminRoleAction.UpdateDfsChequeTracker]: true,
    [AdminRoleAction.UpdateLogisticsPage]: false,
    [AdminRoleAction.UpdateCompaniesConfiguration]: false,
  },
  [MHCRoles.ADMIN]: {
    [AdminRoleAction.UpdateDfsChequeTracker]: false,
    [AdminRoleAction.UpdateLogisticsPage]: false,
    [AdminRoleAction.UpdateCompaniesConfiguration]: true,
  },
  [MHCRoles.AUDIT]: {
    [AdminRoleAction.UpdateDfsChequeTracker]: false,
    [AdminRoleAction.UpdateLogisticsPage]: false,
    [AdminRoleAction.UpdateCompaniesConfiguration]: false,
  },
};

const roleCanPerform = (role: string, action: AdminRoleAction): boolean => {
  if (action === AdminRoleAction.UpdateLogisticsPage) {
    return role === MHCRoles.LOGISTICS;
  }

  // Preserve existing behavior for roles not part of this matrix.
  if (!matrixManagedRoles.has(role)) {
    return true;
  }

  return Boolean(matrixRoleActionPolicy[role]?.[action]);
};

export const canPerformAdminRoleAction = (
  userRoles: string[] | null | undefined,
  action: AdminRoleAction,
): boolean => {
  if (!userRoles?.length) {
    return false;
  }

  return userRoles.some((role) => roleCanPerform(role, action));
};
